import { render, staticRenderFns } from "./Arriendos.vue?vue&type=template&id=2cd2a5e8&"
import script from "./Arriendos.vue?vue&type=script&lang=js&"
export * from "./Arriendos.vue?vue&type=script&lang=js&"
import style0 from "./Arriendos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports